import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface EvaluateMediaHandlerState {
    isOpen: boolean;
    url: string;
    resource_type: string;
    resource_id: string;
    resource_title: string;
}

const initialState: EvaluateMediaHandlerState = {
    isOpen: false,
    url: '',
    resource_type: '',
    resource_id: '',
    resource_title: '',
};

const EvaluateMediaHandlerSlice = createSlice({
    name: 'EvaluatePdfPlayer',
    initialState,
    reducers: {
        setEvaluateMediaHandler: (
            state,
            action: PayloadAction<EvaluateMediaHandlerState>
        ) => {
            state.isOpen = action.payload.isOpen;
            state.url = action.payload.url;
            state.resource_type = action.payload.resource_type;
            state.resource_id = action.payload.resource_id;
            state.resource_title = action.payload.resource_title
        },
    },
});

export const { setEvaluateMediaHandler } = EvaluateMediaHandlerSlice.actions;
export default EvaluateMediaHandlerSlice.reducer;
